export default __webpack_public_path__ + "static/energie-deb962f671ab0f4ccd28e9af9317f84c.png";